import { createSlice } from '@reduxjs/toolkit';
import { fetchFeaturedContentFiles, fetchRoomFileCount, fetchRoomFiles } from './actions';

export interface MediaState {
  roomFiles?: {
    data: [],
    isLoading: boolean
  };
  featuredContentFiles?: {
    data: [],
    isLoading: boolean
  };
  roomFileCount?: number;
}

const initialState: MediaState = {
  roomFiles: {
    data: [],
    isLoading: false
  },
  featuredContentFiles: {
    data: [],
    isLoading: false
  },
};

const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomFiles.fulfilled, (state, action) => {
        state.roomFiles = {
          data: action.payload,
          isLoading: false,
        };
      })
      .addCase(fetchRoomFiles.pending, (state) => {
        state.roomFiles = {
          data: state.roomFiles?.data,
          isLoading: true,
        };
      })
      .addCase(fetchRoomFiles.rejected, (state) => {
        state.roomFiles = {
          data: state.roomFiles?.data,
          isLoading: false,
        };
      })
      .addCase(fetchFeaturedContentFiles.fulfilled, (state, action) => {
        state.featuredContentFiles = {
          data: action.payload,
          isLoading: false,
        };
      })
      .addCase(fetchFeaturedContentFiles.pending, (state) => {
        state.featuredContentFiles = {
          data: state.roomFiles?.data,
          isLoading: true,
        };
      })
      .addCase(fetchFeaturedContentFiles.rejected, (state) => {
        state.featuredContentFiles = {
          data: state.roomFiles?.data,
          isLoading: false,
        };
      })
      .addCase(fetchRoomFileCount.fulfilled, (state, action) => {
        state.roomFileCount = action.payload?.count;
      })
    }
});

export const {} = mediaSlice.actions;

export default mediaSlice.reducer;
